// Setting → Product: แคตตาล็อกสินค้าทั้งหมดจาก Wazzup
import { useMemo, useState } from "react";
import { useNavigate } from "react-router";
import { apiErrorMessage } from "@shared/api/client";
import { IconSearch } from "@shared/ui/icons";
import { useEnabledBrands, useProducts } from "../api/use-settings";
import { ProductLogo } from "../components/product-logo";

const SHOW_LIMIT = 200;

export function ProductListPage() {
  const navigate = useNavigate();
  const { data, isPending, isError, error } = useProducts();
  const { byId: enabled } = useEnabledBrands();
  const [q, setQ] = useState("");
  const [activeOnly, setActiveOnly] = useState(true);

  const items = useMemo(() => {
    const needle = q.trim().toLowerCase();
    // productCode เป็น string มี leading zero — ห้ามแปลงเป็นตัวเลข
    return (data ?? []).filter((p) => {
      if (activeOnly && p.productActive !== "Y") return false;
      if (!needle) return true;
      return [
        p.productCode,
        p.productEngName,
        p.productThName,
        p.brandCode,
        p.brandEngName,
        p.brandThName,
        p.clientCode,
        p.clientEngName,
        p.clientThName,
      ].some((v) => (v || "").toLowerCase().includes(needle));
    });
  }, [data, q, activeOnly]);

  return (
    <>
      <div className="content-head">
        <div>
          <div className="breadcrumb">Setting / Product</div>
          <h1>All Products</h1>
        </div>
      </div>

      {isPending ? (
        <div className="panel">
          <p className="muted">กำลังโหลดข้อมูล…</p>
        </div>
      ) : isError ? (
        <div className="panel">
          <p className="muted">
            โหลดข้อมูลสินค้าไม่สำเร็จ กรุณาลองใหม่อีกครั้ง ({apiErrorMessage(error)})
          </p>
        </div>
      ) : (
        <>
          <div className="toolbar">
            <div className="search-box grow-box">
              <IconSearch />
              <input
                type="text"
                placeholder="ค้นหาสินค้า แบรนด์ ลูกค้า หรือรหัส..."
                value={q}
                onChange={(e) => setQ(e.target.value)}
              />
            </div>
            <label className="check-label">
              <input
                type="checkbox"
                checked={activeOnly}
                onChange={(e) => setActiveOnly(e.target.checked)}
              />{" "}
              เฉพาะ Active
            </label>
            <span className="muted">{items.length.toLocaleString()} รายการ</span>
          </div>

          <div className="product-grid">
            {items.slice(0, SHOW_LIMIT).map((p) => (
              <div
                key={p.productCode}
                className="product-card clickable"
                onClick={() => navigate(`/setting/product/${encodeURIComponent(p.productCode)}`)}
              >
                <ProductLogo url={p.productLogoURL} letter={(p.productEngName || "?").charAt(0)} />
                <div className="product-info">
                  <div className="product-name" title={p.productEngName || ""}>
                    {p.productEngName || "-"}
                  </div>
                  <div className="product-sub">
                    {p.brandEngName || "-"} · {p.clientEngName || "-"}
                  </div>
                  <div className="product-meta">
                    <span className="code-chip">#{p.productCode}</span>
                    {p.productActive === "Y" ? (
                      <span className="badge badge-green">Active</span>
                    ) : (
                      <span className="badge badge-gray">Inactive</span>
                    )}
                    {enabled.has(p.productCode) && (
                      <span className="badge badge-blue">In My Job</span>
                    )}
                  </div>
                </div>
              </div>
            ))}
            {items.length > SHOW_LIMIT && (
              <div className="muted more-note">
                แสดง {SHOW_LIMIT} รายการแรก — พิมพ์ค้นหาเพื่อกรองเพิ่ม
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
}
